import { render, staticRenderFns } from "./TaSteps.vue?vue&type=template&id=7a246062&scoped=true&"
import script from "./TaSteps.vue?vue&type=script&lang=js&"
export * from "./TaSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a246062",
  null
  
)

export default component.exports